export default {
  methods : {
    /**
     * Retourne une promise encapsulant l'animation de transition
     * Ne pas modifier cette méthode directement
     * Modifier la méthode `transitionIn` à la place
     *
     * @return {Promise}
     */
    transitionInPromise ()
    {
      return new Promise( (resolve, reject) => this.transitionIn(resolve) )
    },
    /**
     * Animation d'introduction
     * N'utiliser que si besoin (sinon l'annimation par défaut sera activée)
     * Ne pas oublier d'appeler le callback "done" une fois l'animation finie
     *
     * @args {Function} - resolve callback de la Promise retournée par méthode `transitionInPromise`
     */
    transitionIn( ended )
    {
      ended()
    }
  }
}